import getOr from 'lodash/fp/getOr'
import sortBy from 'lodash/fp/sortBy'
import { createSelector } from 'reselect'
import { createEntitiesSelector, denormalize } from '../../utils/normalize'
import { activityListSchema, activitySchema } from './model'

export const selectActivitiesState = getOr({}, 'activities')

export const selectActivitiesAllState = createSelector(
  selectActivitiesState,
  getOr({}, 'all')
)

export const isActivitiesAllRequesting = createSelector(
  selectActivitiesAllState,
  getOr(false, 'requesting')
)

export const selectActivitiesAllError = createSelector(
  selectActivitiesAllState,
  getOr(null, 'error')
)

export const selectActivitiesAllResults = createSelector(
  selectActivitiesAllState,
  getOr([], 'results')
)

export const hasActivitiesAllResults = createSelector(
  selectActivitiesAllResults,
  ids => ids.length > 0
)

export const selectActivitiesAllEntities = createEntitiesSelector(
  selectActivitiesAllResults,
  denormalize(activityListSchema)
)

export const selectActivitiesSortedEntities = createSelector(
  selectActivitiesAllEntities,
  sortBy('description')
)

export const shouldFetchActivitiesAgain = createSelector(
  isActivitiesAllRequesting,
  hasActivitiesAllResults,
  selectActivitiesAllError,
  (requesting, hasActivities, error) => !requesting && (!hasActivities || Boolean(error))
)

export const selectPropCode = (_, props) => props.code

export const selectActivityByPropCode = createEntitiesSelector(
  selectPropCode,
  denormalize(activitySchema)
)
